import { useEffectOnMount } from '@onramp/hooks/useEffectOnMount';
import { onCLS, onFCP, onFID, onLCP, onTTFB } from 'web-vitals';

import type { MetricDefinitionMap } from './metrics';
import { logWidgetMetricOnce } from './metrics';

// The Coinbase client analytics library also reports web vitals metrics, but those metrics don't make it to Datadog
// due to filters put in place by infra to reduce datadog costs, since many teams don't use these metrics. We need web
// vitals metrics do monitor our FE latency, so we report them ourselves and monitor them in Datadog.
// See https://docs.cbhq.net/frontend/analytics/log-metrics#blocking-metrics-from-datadog
type LogWebVitalMetricParams = {
  metricValue: number;
  vitalType: MetricDefinitionMap['perf_web_vital']['tags']['vital_type'];
};
const logWebVitalMetric = ({ metricValue, vitalType }: LogWebVitalMetricParams) => {
  logWidgetMetricOnce({
    metricName: 'perf_web_vital',
    value: metricValue,
    tags: { vital_type: vitalType },
  });
};

// See https://web.dev/vitals/ for more details on these metrics.
export const useReportWebVitals = () => {
  // This must only trigger once per page load as each 'on' method creates a new event listener.
  useEffectOnMount(() => {
    onTTFB((metric) => {
      logWebVitalMetric({
        metricValue: metric.value,
        vitalType: 'ttfb',
      });
    });
    onLCP((metric) => {
      logWebVitalMetric({
        metricValue: metric.value,
        vitalType: 'lcp',
      });
    });
    onFID((metric) => {
      logWebVitalMetric({
        metricValue: metric.value,
        vitalType: 'fid',
      });
    });
    onCLS((metric) => {
      logWebVitalMetric({
        metricValue: metric.value,
        vitalType: 'cls',
      });
    });
    onFCP((metric) => {
      logWebVitalMetric({
        metricValue: metric.value,
        vitalType: 'fcp',
      });
    });
  });
};
